export default <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <path d='M9 6V18M15 6V18' stroke='#2F3A41' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
</svg>
